/* Avaliações da página de produto (DIRECAO-CARD-PDP.md 8.5). O estado vazio é nosso ("Seja o primeiro a avaliar"); o botão "Avaliar produto"
   só aparece quando existe o botão real do Ryviu, e clicar nele abre o formulário do Ryviu (sem formulário real, sem botão morto).
   O Ryviu desenha o widget quando o bloco entra na tela e sem aviso: um MutationObserver espera o botão dele por até 30 s. */
(function () {
  'use strict';
  var app = document.querySelector('#avaliacoes .av-app');
  var nosso = document.querySelector('#avaliacoes [data-av-abrir]');
  if (!app || !nosso) return;
  var REAL = '.Ryviu-Write-Button';
  var espera = null;
  function liga() {
    var real = app.querySelector(REAL);
    nosso.hidden = !real;
    if (real && espera) { espera.disconnect(); espera = null; }
  }
  nosso.addEventListener('click', function () {
    var real = app.querySelector(REAL);
    if (real) real.click();
  });
  if (typeof MutationObserver === 'function') {
    espera = new MutationObserver(liga);
    espera.observe(app, { childList: true, subtree: true });
    window.setTimeout(function () { if (espera) { espera.disconnect(); espera = null; } }, 30000);
  }
  liga();
})();
